import { ContentProvider } from '@awp/content';
import { EMPTY } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { isNullOrEmpty, getRouteSegment, getParentRouteWithDataProperty, extractValueFromParams } from '@awp/core/utils';
import * as i0 from "@angular/core";
import * as i1 from "../../../../content/src/lib/content.provider";
var ContentErrorPageResolver = /** @class */ (function () {
    function ContentErrorPageResolver(contentProvider) {
        this.contentProvider = contentProvider;
    }
    ContentErrorPageResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var pageId = route.paramMap.get('pageId');
        var themeId = extractValueFromParams(route, 'themeId');
        var purchaseSegment = getRouteSegment(getParentRouteWithDataProperty(route, 'isPurchasePath'));
        return this.contentProvider.fetchRoot()
            .pipe(filter(function (p) { return p != null && p._embedded != null && p._embedded.errorPages != null; }), map(function (p) { return p._embedded.errorPages.errors; }), map(function (errorPages) {
            var errorPage = errorPages.find(function (i) { return i.url === pageId
                && ((isNullOrEmpty(themeId) && isNullOrEmpty(i.parentUrl))
                    || (i.parentUrl === ':themeId' && !isNullOrEmpty(themeId) && purchaseSegment == null)
                    || (i.parentUrl === ":themeId\\" + purchaseSegment)); });
            return errorPage != null && errorPage._link != null && errorPage._link.self != null
                ? errorPage._link.self.href
                : null;
        }), mergeMap(function (url) { return isNullOrEmpty(url) ? EMPTY : _this.contentProvider.fetchContent(url); }));
    };
    ContentErrorPageResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContentErrorPageResolver_Factory() { return new ContentErrorPageResolver(i0.ɵɵinject(i1.ContentProvider)); }, token: ContentErrorPageResolver, providedIn: "root" });
    return ContentErrorPageResolver;
}());
export { ContentErrorPageResolver };
